import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EM_DASH } from 'libs.react';
const BORDER = '#E5E7EB';
const CARD_STYLE = {
    overflow: 'hidden',
    background: '#FFFFFF',
    border: `1px solid ${BORDER}`,
    borderRadius: 8,
};
const ROW_STYLE = {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '14px 18px',
    gap: 16,
};
const LABEL_STYLE = {
    width: 210,
    flexShrink: 0,
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: 400,
    color: '#6B7280',
};
const VALUE_STYLE = {
    flex: 1,
    minWidth: 0,
    fontSize: 13.5,
    lineHeight: '19px',
    fontWeight: 400,
    color: '#374151',
};
const TONE_STYLE = {
    default: {},
    status: {
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 500,
    },
    danger: {
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 500,
        color: '#991B1B',
    },
    warning: {
        fontWeight: 500,
        color: '#713F12',
    },
};
export const DocumentDetailFieldColumn = ({ items, dataTestId }) => {
    const visible = items.filter((item) => !item.hidden);
    return (_jsx("div", { "data-testid": dataTestId, style: CARD_STYLE, children: visible.map((item, index) => {
            const isLast = index === visible.length - 1;
            const isEmpty = item.description == null || (typeof item.description === 'string' && item.description.trim().length === 0);
            return (_jsxs("div", { "data-testid": item.dataTestId, style: {
                    ...ROW_STYLE,
                    borderBottom: isLast ? undefined : `1px solid ${BORDER}`,
                }, children: [_jsx("div", { style: LABEL_STYLE, children: item.title }), _jsx("div", { style: { ...VALUE_STYLE, ...TONE_STYLE[item.tone ?? 'default'] }, children: isEmpty ? EM_DASH : item.description })] }, item.dataTestId ?? item.title));
        }) }));
};
